import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AgencyRequiredDocumentModel } from "src/app/Model/AgencyRequiredDocument.model";
import { ConnectionTypeDocumentModel } from "src/app/Model/ConnectionTypeDocument.model";
import { ConnectionTypeDocumentViewModel } from "src/app/Model/ConnectionTypeDocumentView.model";
import { ContractTermsAgencyModel } from "src/app/Model/ContractTermsAgency.model";
import { RequestModel } from "src/app/Model/Request.model";
import { SignatureUsersModel } from "src/app/Model/SignatureUsers.model";
import { VStatusDocumentUpdated } from "src/app/Model/VStatusDocumentUpdated";
import { BaseService } from "../Base/BaseService";
import { SessionStorageService } from "../sessionStorageService/session-storage.service";
import { AuthService } from "../Interceptor/auth.service";
import { LoadFileModel } from "src/app/Model/LoadFile.Model";

@Injectable({
  providedIn: "root",
})
export class DocumentService extends BaseService {
  constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) {
    super(http, lsService,authService);
    this.Component = "DocumentService";
  }

  public async getGetConnectionDocumentByIdConectionView(data){
    let Document: ConnectionTypeDocumentViewModel[];
    await this.PostData(data,"Document","GetConnectionDocumentByIdConectionView").then((res) => {
      //await this.PostData(data,"Document","GetConnectionDocumentById").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async getGetConnectionDocumentByIdConection(data){
    let Document: ConnectionTypeDocumentModel[];
    await this.PostData(data,"Document","GetConnectionDocumentById").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async getGetConsultConnectionDocumentByIdConection(data){
    let Document: ConnectionTypeDocumentModel[];
    await this.PostData(data,"Document","GetConsultConnectionDocumentById").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async getRequestByCode(data){
    let Document: RequestModel;
    await this.PostData(data,"Document","GetRequestByCode").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async GetAgencyDocumentsF1(data){
    let Documents: AgencyRequiredDocumentModel[];
    await this.PostData(data,"Document","GetAgencyDocumentsF1").then((res) => {
      if(res.head.status != 'False') {
        Documents = JSON.parse(res.body.response);
      }
    });
    return Documents;
  }
  public async getUrlTyC(data){
    let Url: string;
    await this.PostData(data,"Document","GetUrlTyC").then((res) => {
      if(res.head.status != 'false'){
        Url = JSON.parse(res.body.response);
      }
    });
    return Url;
  }

  public async getDocumentsbyRequest(data){
    let Document: AgencyRequiredDocumentModel[];
    await this.PostData(data,"Document","GetDocumentsbyRequest").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async getViewDocumentsbyRequest(data){
    let Document: AgencyRequiredDocumentModel[];
    await this.PostData(data,"Document","GetViewDocumentsbyRequest").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async GetStatusDocumentUpdatedByIdRequest(data){
     let status: VStatusDocumentUpdated[];
     await this.PostData(data,"Document","GetStatusDocumentUpdatedByIdRequest").then((res) => {
      if(res.head.status != 'False') {
        status = JSON.parse(res.body.response);
      }
    });
    return status;
  }


  public async getSignatureUsersByRequest(data){
    let SignatureUsers: SignatureUsersModel[];
    await this.PostData(data,"Document","GetSignatureUsersByRequest").then((res) => {
      if(res.head.status != 'False') {
        SignatureUsers = JSON.parse(res.body.response);
      }
    });
    return SignatureUsers;
  }


  public async getContractTermsAgencyByCode(data){
    let ContractTermsAgency: ContractTermsAgencyModel;
    await this.PostData(data,"Document","GetContractTermsAgencyByCode").then((res) => {
      if(res.head.status != 'False') {
        ContractTermsAgency = JSON.parse(res.body.response);
      }
    });
    return ContractTermsAgency;
  }


  public async postDocument(data){
    let Document: AgencyRequiredDocumentModel;
    await this.PostData(data,"Document","Post").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return Document;
  }

  public async postContractTermsAgency(data){
    let Document: ContractTermsAgencyModel;
    await this.PostData(data,"Document","PostContractTermsAgency").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return Document;
  }

  public async deleteDocument(data){
    let Document: AgencyRequiredDocumentModel;
    await this.PostData(data,"Document","Delete").then((res) => {
      if(res.head.status != 'False') {
        Document = JSON.parse(res.body.response);
      }
    });
    return Document;
  }

  public async CompleteDocument(data){
    let Request: RequestModel;
    await this.PostData(data,"Document","CompleteDocument").then((res) => {
      if(res.head.status != 'False') {
        Request = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return Request;
  }


  public async AgencyContractAcept(data){
    let Request: RequestModel;
    await this.PostData(data,"Document","AgencyContractAcept").then((res) => {
      if(res.head.status != 'False') {
        Request = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return Request;
  }


  public async AgencyContractReject(data){
    let Request: RequestModel;
    await this.PostData(data,"Document","AgencyContractReject").then((res) => {
      if(res.head.status != 'False') {
        Request = JSON.parse(res.body.response);
      }else{
        let any = res.body.response
        return any
      }
    });
    return Request;
  }

  public async GetAccessLetterPrint(data) {
    let Request: string;
    await this.PostData(data, "Document", "GetAccessLetterPrint").then((res) => {

      Request = JSON.parse(res.body.response);
      
      return Request;
    });
    return Request;
  }

  public async getDocumentsInRevision(data){
    let document: any;
    await this.PostData(data,"Document","getDocumentsInRevision").then((res) => {
      if(res.head.status != 'False') {
        document = JSON.parse(res.body.response);
      }
    })
    return document;
  }

  public async getDocumentsApproval(data){
    let document: any;
    await this.PostData(data,"Document","getDocumentsApproval").then((res) => {
      if(res.head.status != 'False') {
        document = JSON.parse(res.body.response);
      }
    })
    return document;
  }

  public async getValidateTermsAndConditions(data){
    let document: any;
    await this.PostData(data,"Document","getValidateTermsAndConditions").then((res) => {
      if(res.head.status != 'False') {
        document = JSON.parse(res.body.response);
      }
    })
    return document;
  }

  public async getValidateTraining(data){
    let document: any;
    await this.PostData(data,"Document","getValidateTraining").then((res) => {
      if(res.head.status != 'False') {
        document = JSON.parse(res.body.response);
      }
    })
    return document;
  }

  public async deleteAllFilesFromFolder(data: LoadFileModel){
    let document: boolean;
    await this.PostData(data,"Document","DeleteAllFilesInFolder").then((res) => {
      if(res.head.status != 'False') {
        document = JSON.parse(res.body.response);
      }
    })
    return document;
  }

  public async uploadFile(data: LoadFileModel){
    let document: string;
    await this.PostData(data,"Document","UploadFile").then((res) => {
      if(res.head.status != 'False') {
        document = JSON.parse(res.body.response);
      }
    })
    return document;
  }

}
